import React, { useContext, useState } from 'react'
import { getImages } from '../Const'
import { UserContext } from '../Context/UserContext'

const Header = () => {

    const { user, logout } = useContext(UserContext);
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };

    return (
        <>
            <header className="header-wrap">
                <div className="container-fluid">
                    <div className="header-block d-flex align-items-center">
                        <div className="header-left">
                            <a href="index.html" className="main-logo">
                                <img src={getImages('main-logo.png')} alt='logo' />
                            </a>
                        </div>
                        <div className="header-right d-flex align-items-center justify-content-between menu-block">
                            <div className={`d-flex w-100 align-items-center justify-content-between menus-for-mobile ${isMob ? 'active' : ''}`}>
                                <div className="main-menu">
                                    <ul>
                                        <li>
                                            <a href="/">Dashboard</a>
                                        </li>
                                        <li>
                                            <a href="/lead">Leads</a>
                                        </li>
                                        {/* <li>
                                            <a href="#">Tasks</a>
                                        </li>
                                        <li>
                                            <a href="#">Tools</a>
                                        </li>
                                        <li>
                                            <a href="#">Report</a>
                                        </li>
                                        <li>
                                            <a href="#">Menu Item</a>
                                        </li>
                                        <li>
                                            <a href="#">Menu Item</a>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className="login-block">
                                    {/*<div className="btn-group custom-dropdown">
                                        <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src={getImages('buil-icon.svg')}/> Little Rock, AR
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <button className="dropdown-item" type="button">Action</button>
                                            <button className="dropdown-item" type="button">Another action</button>
                                            <button className="dropdown-item" type="button">Something else here</button>
                                        </div>
                                    </div>*/}
                                    <div className="btn-group custom-dropdown ms-3">
                                        <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src={getImages('user-icon.svg')} /> Welcome {user && user.first_name}
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <button className="dropdown-item" type="button" onClick={() => logout()}>Logout</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`overflow-bg d-none ${isMob ? 'active' : ''
                                }`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            ></div>
                            <div className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}>
                                <div className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                    }`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header